import LogentryModel from '../model/LogentryModel'
import TimestampControl from '../../../lib/ui/TimestampControl'
import TextAreaControl from '../../../lib/ui/TextAreaControl'

export default class LogentryForm {
  constructor (element, args) {
    let fieldsetLogentry = document.createElement('fieldset')
    let legendLogentry = document.createElement('legend')
    legendLogentry.innerHTML = 'Logboekregel'
    fieldsetLogentry.appendChild(legendLogentry)

    this.id = args.logentry.values.id
    this.target_id = args.logentry.values.target_id
    this.object_type_id = args.logentry.values.object_type_id

    this.timestamp = new TimestampControl(fieldsetLogentry, {label: 'Tijdstempel', value: args.logentry.values.timestamp, readonly: window.PRIM.hasReadonlyModuleAccess('logentries'), onchange: args.onchange})
    this.description = new TextAreaControl(fieldsetLogentry, {label: 'Omschrijving', value: args.logentry.values.description, readonly: window.PRIM.hasReadonlyModuleAccess('logentries'), onchange: args.onchange})

    let fragment = document.createDocumentFragment()
    fragment.appendChild(fieldsetLogentry)

    element.appendChild(fragment)
  }

  getValue () {
    let logentry = new LogentryModel()
    logentry.values.id = this.id
    logentry.values.target_id = this.target_id
    logentry.values.object_type_id = this.object_type_id
    logentry.values.timestamp = this.timestamp.getValue()
    logentry.values.description = this.description.getValue()
    return logentry
  }

  setValue (logentry) {
    this.id = logentry.values.id
    this.target_id = logentry.values.target_id
    this.object_type_id = logentry.values.object_type_id
    this.timestamp.setValue(logentry.values.timestamp)
    this.description.setValue(logentry.values.description)
  }
}



// WEBPACK FOOTER //
// ./js/modules/logentry/ui/LogentryForm.js